import { render } from "./BlockEditor.vue?vue&type=template&id=3a359ef1"
import script from "./BlockEditor.vue?vue&type=script&lang=js"
export * from "./BlockEditor.vue?vue&type=script&lang=js"

import "./BlockEditor.vue?vue&type=style&index=0&id=3a359ef1&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__